import { apiConfig, appConfig } from '@oneview/config';
import { AppVariant } from '@oneview/constants/lookups';

export function isAdvisor() {
    return appConfig.appVariant === AppVariant.Advisor;
}

export function isProduction() {
    return appConfig.nodeEnv === 'production' && !appConfig.appEnv.includes('development');
}

export function isDevelopment() {
    return appConfig.nodeEnv === 'development';
}

export function isAxos() {
    return appConfig.appEnv.includes('axos');
}

export function isAxosClient() {
    return appConfig.appEnv.includes('axos') && !isAdvisor();
}

export function isIndia() {
    return appConfig.appEnv.includes('india');
}

export function isUma() {
    return !!apiConfig.umaApiUrl;
}

export function isMidasQuoteSource() {
    return Boolean(apiConfig.umaApiUrl) && appConfig.quoteSource === 'midas';
}
